import React, { useEffect, lazy, Suspense, useState } from "react";
import {
  useParams,
  useLocation,
  useHistory,
  useRouteMatch,
} from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import StoreNav from "../components/StoreNav/StoreNav";
import Carousel from "../components/Carousel/Carousel";
import Banner from "../containers/Banner/Banner";
import Sidebar from "../containers/Sidebar/Sidebar";
import Spinner from 'react-bootstrap/Spinner';
import expressService from "../services/expressService";

// import Products from "../containers/Products/Products";
import CartPopUp from "../containers/Cart/CartPopUp";
import LazyLoader from "../components/LazyLoader/LazyLoader";
import {
  MainContentArea,
  SidebarSection,
  ContentSection,
  WaitingScreen,
  OfferSection,
  MainHeader,
  MobileCarouselDropdown,
} from "../styled/pages.style";
import { useDeviceType } from "../helper/useDeviceType";
import { useCart } from "../contexts/cart/use-cart";
import { useFavorites } from "../contexts/favorites/use-favorites";
// Static Data Import Here
// import OFFERS from '../data/offers';
import BannerImg from "../image/grocery.png";
import storeType from "../constants/storeType";
import queryString from "query-string";
import { connect, createDispatchHook } from "react-redux";
import {
  productCategory,
  ProductModalData,
  searchSuggestions,
  searchStoreProduct,
  getProductsMappedwithSubCat,
  getProductsMappedwithCat,
  getProductOutOfStock,
  getProductOutOfStockCat,
  getProductBrands,
  getBrandByName,
  getProductFilterBrands,
  getSortProductsName,
  getSortProductsPrice,
  sortByNameProduct,
  SearchStoreProductByBrandRef,
  Toggle_Suggestions,
  changePage,
  resetPage,
  getBrandBySlug
} from "../store/actions/productAction";
import {
  oosModified,
} from "../store/actions/globalAction"
import { SearchContext } from "../contexts/search/search.context";
import { offerSlider } from "../store/actions/globalAction";
import {cats} from "../helper/constant";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { BreadcrumbItem } from "react-bootstrap";
import Button from "../components/Button/Button";
import { setCookie, getCookie } from "../helper/constant";
import t from '../i18n/translate';
import { logDOM } from "@testing-library/react";
import styled from "styled-components";
import SidebarFilter from "../components/SideBarFilter/SideBarfilter";
import { borderRight } from "styled-system";
import { Button as MButton } from "@material-ui/core";
import { logEventView } from "../services/googleAnalytics";
import { Tune } from "@material-ui/icons";

const PAGE_TYPE = "grocery";
const Products = lazy(() => import('../containers/Products/Products'));
const useRouter = () => {
  const params = useParams();

  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return React.useMemo(() => {
    return {
      // For convenience add push(), replace(), pathname at top level
      push: history.push,
      replace: history.replace,
      pathname: location.pathname,
      // Merge params and parsed query string into single "query" object
      // so that they can be used interchangeably.
      // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
      query: {
        ...queryString.parse(location.search), // Convert string to object
        ...params,
      },
      // Include match, location, history objects so we have
      // access to extra React Router functionality if needed.
      match,
      location,
      history,
    };
  }, [params, match, location, history]);
};

const SearchedResults = (props, { userAgent, storeId }) => {
  const deviceType = useDeviceType(userAgent);
  const router = useRouter();
  let { catrefid, subcatrefid, text, brandName } = useParams();
  const { query, history } = useRouter();
  let mql = window.matchMedia("all and (min-width: 991px)");
  let mqs = window.matchMedia("all and (max-width: 768px)");
  const { state, searchdispatch } = React.useContext(SearchContext);
  const targetRef = React.useRef(null);
  const [catName, setCatName] = useState("");
  const [showBN, setShowBN] = useState(true);
  const [doOnlyOneTime, setDoOnlyOneTime] = useState(true);
  const [isSpinning, setIsSpinning] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [selected, setSelected] = useState([]);
  const [selectedCat, setSelectedCat] = useState([]);
  const [isFilter, setIsFilter] = useState(null)
  const [filterShow, setFilterShow] = useState(false);
  const [bvalues, setBValues] = useState([]);
  const[itemCategory, setItemCategory] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [catvalues, setCatValues] = useState([]);
  const [isOutOfStock, setIsOutOfStock] = useState(0);
  const [sort, setSort] = useState('');
  const SUB_CAT_ID = localStorage.getItem("sub_cat_id");
  const [catId, setCatId] = useState([]);
  const [showFilterNotFound, setShowFilterNotFound] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [brandFetching, setBrandFetching] = useState(true)

  useEffect(() => {
    if(showFilter === false){
      localStorage.removeItem('isfilter')
    }else{
      localStorage.setItem('isfilter',true)
    }
  },[showFilter]);
  
  const {
    fetchOrderItems,
  } = useCart();
  const {
    fetchFavorites,
  } = useFavorites();
  const lang = localStorage.getItem('lang') || 'en';

  useEffect(() => {
    if(doOnlyOneTime) {
      setTimeout(() => {
        window.scrollTo({ top: 0 });
        setDoOnlyOneTime(false);
      }, 250)
    }
  }, [doOnlyOneTime])

  const openFilterModal = () => {
    setShowFilter(!showFilter)
  }

  const modifyBranDescription = (e) => {
    if(e){
      return e.split('\n');
    }else {
      return []
    }
  }

  /**
   * useEffect hook to fetch brand data when the component mounts.
   * This effect runs only once due to the empty dependency array.
   */
  useEffect(() => {
    /**
     * Asynchronous function to fetch brand data.
     * It checks if the current URL path includes "brand".
     * If true, it fetches product brands and brand details by slug.
     */
    const fetchBrandData = async () => {
      // Check if the current URL path includes "brand"
      if (!window.location.pathname.split("/").includes("brand")) return;

      // Set the brand fetching state to true
      setBrandFetching(true);
      try {
        // Fetch brand details by slug
        await props.getBrandBySlug(brandName);
      } catch (error) {
        // Log any errors that occur during the fetch
        console.error("Error fetching brand data:", error);
      } finally {
        // Set the brand fetching state to false
        setBrandFetching(false);
      }
    };

    // Call the fetchBrandData function
    fetchBrandData();

    // Fetch brands all page products list
    props.getProductBrands();
  }, []);


  const brandLogo = () => {
    if (window.location.pathname.split("/").indexOf("brand")){
      //logo brand page
      return <>
        <div className="container-fluid d-flex justify-content-center align-items-center py-4">
          <div className="text-center">
            <img src={props.brandDetail?.logo} alt="..." className="img-rounded" width={100} />
            <h4 className="mb-3">{props.brandDetail?.name}</h4>
            <div>{props.brandDetail?.description && modifyBranDescription(props.brandDetail?.description).map((e) => <h5>{e}</h5>)}</div>
          </div>
        </div>
      </>
    }
  }

  const breadCrumbmatch = () => {
    if (window.location.pathname.split("/").indexOf("brand") >= 0){
      //brand page
      return <>
        <Breadcrumb.Item href={"/brands"} className="bread_crumb_wrapper" style={{ display: "flex", alignItems: "center" }}>
        {"All Brands"}
        </Breadcrumb.Item>
        <Breadcrumb.Item href={"/brand/" + brandName} className="bread_crumb_wrapper" active style={{ display: "flex", alignItems: "center" }}>
        {brandName}
        </Breadcrumb.Item>
      </>
    }
    else if(window.location.pathname.split("/").indexOf("brand") >= 0){
      //allbrands
      return <>
        <Breadcrumb.Item href={"/brands"} className="bread_crumb_wrapper" active style={{ display: "flex", alignItems: "center" }}>
        {"All Brands"}
        </Breadcrumb.Item>
      </>
    }
    else if(catrefid !== undefined && subcatrefid !== undefined){
      //subcat
      return <>
	      <Breadcrumb.Item href={"/category/" + catrefid} className="bread_crumb_wrapper"
	                       style={{display: "flex", alignItems: "center"}}>
          {catName}
        </Breadcrumb.Item>
	      <Breadcrumb.Item href={"/category/" + catrefid + "/" + subcatrefid} className="bread_crumb_wrapper" active
	                       style={{display: "flex", alignItems: "center"}}>
          {localStorage.getItem("subcatname")}
        </Breadcrumb.Item>
      </>
    }
    else{
      //cat
      return <>
	      <Breadcrumb.Item href={"/category/" + catrefid} className="bread_crumb_wrapper" active
	                       style={{display: "flex", alignItems: "center"}}>
          {catName}
        </Breadcrumb.Item>
      </>
    }
  };

  const checkifcat = () => {
    const cat = props.category.filter((element, index) => {
	    return element.cat_ref_id === window.location.pathname.split("/category/")[1]
    });
    if(cat.length > 0){
      return true;
    }
    else{
      return false;
    }
  }

  useEffect(() => {
    document.getElementsByClassName("product-cart")[0].style.visibility = "hidden";
    if(!props.category.length){

      props.productCategory({ get_type: 2, store_id: 1, lang });

      if (text && text.length >= 3) {
        props.searchSuggestions({ search_query: text, store_id: 1 });
      }
    }
  }, []);

  // localStorage.setItem("mode", "brand");
  const setSelectedBrands = async (values = selected, catValues = selectedCat, min = min, max = max, is_filter = isFilter) => {
    setFilterShow(false);

    let b = values.map((el) => {
      return el.value;
    });

    let c = catValues.map((el) => {
      return el.value;
    });
    let allSelected = [];
    allSelected.brands = values;
    allSelected.category = catValues;
    allSelected.min = min;
    allSelected.max = max;
    allSelected.isFilter = is_filter
    setBValues(b)
    setItemCategory(b)
    setCatValues(c);
    setAllCategory(c);
    if (props.cartType && props.cartType === 'express') {
      let filteredProducts = { brandIdList: [], categorySelected: [], subCategorySelected: [], outOfStock: 0, search: '', sort: '' };
      filteredProducts.brandIdList = b;
      if (!Array.isArray(props.filteredProducts) && Object.keys(props.filteredProducts).length) {
        filteredProducts.categorySelected = props.filteredProducts.categorySelected;
        filteredProducts.subCategorySelected = props.filteredProducts.subCategorySelected;
        filteredProducts.search = props.filteredProducts.search;
        filteredProducts.sort = props.filteredProducts.sort;
      }

      const itemsList = await expressService.storeItems(
        [storeId],
        b,
        filteredProducts.categorySelected,
        filteredProducts.subCategorySelected,
        isOutOfStock,
        filteredProducts.search,
        sort
      );

      if (itemsList.list.length) {
        setCatId(b);
        props.initProductExpressStore(itemsList.list);
        props.sortProducts(filteredProducts);
      }
      else {
        setShowFilterNotFound(true)
      }
    }
    else {
      props.getProductFilterBrands(
        allSelected,
        props.products,
        props.allproducts,
        SUB_CAT_ID,
        localStorage.getItem("cat_id"),
        props.oos,
        state.text,
      );
    }
  };
  // props.SearchStoreProductByBrandRef({
  //   "store_id": 1,
  //   "brand_ref_id": brandName,
  // });


  // update route category and sub category default don't have /category update to /category for mobile deeplink
  const updatePageRoute = () => {
    let url = window.location.pathname;
    let newUrl = url.split("/").filter(Boolean);
    
    // Preserve the query string from the current URL
    const queryParams = window.location.search;
  
    if (newUrl[0] !== "category" && newUrl[0] !== "best-deals") {
      newUrl.unshift("category");
    }
  
    url = "/" + newUrl.join("/") + queryParams; // Add query params back
  
    history.replace(url);
  };
  

  useEffect(async () => {
    if (props.category.length > 0 && window.location.pathname.split("/")[1] === "search") {
      document.getElementsByClassName("SearchBox")[0].value = text;
      if(mqs.matches){
        document.getElementsByClassName("searchIconWrapper")[0].click();
      }
      localStorage.setItem("mode","search");
      searchdispatch({
        type: "UPDATE",
        payload: {
          ...state,
          text,
        },
      });
    }
    else if (window.location.pathname.split("/")[1] === "brand"){
      localStorage.setItem("mode","brand");
      props.SearchStoreProductByBrandRef({
        "store_id": 1,
        "brand_ref_id": brandName,
        // "cat_id": [17,4]
      });
    }
    else if (props.category.length > 0 && checkifcat && !subcatrefid){
      let isCat = 0;
      props.category.map((element, index) => {
        if (element.cat_ref_id === window.location.pathname.split("/")[1] || element.cat_ref_id === window.location.pathname.split("/category/")[1]) {
          updatePageRoute()
          setCatName(element.name);
          isCat = 1;
          if(props.oos){
            localStorage.setItem("mode","catoos");
            localStorage.setItem("cat_id",element.cat_id);
            props.resetPage();
            props.getProductOutOfStockCat({
              cat_id: element.cat_id,
              store_id: 1,
              page: 1,
              oos: props.oos,
              brand_id: 0
            });
          }
          else{
            localStorage.setItem("mode","cat");
            localStorage.setItem("cat_id",element.cat_id);
            props.resetPage();
            props.getProductsMappedwithCat({
              cat_id: element.cat_id,
              store_id: 1,
              page: 1,
              oos: props.oos,
              brand_id: 0
            });
          }
          if(document.getElementById("oosbtn")){
            document.getElementById("oosbtn").click();
          }
          localStorage.setItem("sub_cat_id",0);
          localStorage.setItem("subcatname", "");
        }
      });
      if (isCat === 0){
        history.push(`/not-found`);
      }
    }
    else if (props.category.length > 0 && catrefid && subcatrefid) {
      let isSubCat = 0;
      let isCat = 0;
      props.category.map((element, index) => {
        if (element.cat_ref_id == catrefid) {
          isCat = 1;
          updatePageRoute()
          element.map_categories_sub_cats.map((sub_cat, idx1) => {
            sub_cat.list_sub_categories.map((sub_name, idx2) => {
              if (sub_name.sub_cat_ref_id == subcatrefid) {
                isSubCat = 1;
                localStorage.setItem("sub_cat_id", sub_name.sub_cat_id);
                localStorage.setItem("subcatname", sub_name.name);
                setCatName(element.name);
                if(!props.oos){
                  localStorage.setItem("mode","subcatoos");
                  props.resetPage();
                  props.getProductOutOfStock({
                    sub_cat_id: sub_name.sub_cat_id,
                    store_id: 1,
                    page: 1,
                    oos: props.oos,
                    brand_id: 0,
                    lang
                  });
                }
                else{
                  localStorage.setItem("mode","subcat");
                  props.resetPage();
                  props.getProductsMappedwithSubCat({
                    sub_cat_id: sub_name.sub_cat_id,
                    store_id: 1,
                    page: 1,
                    oos: props.oos,
                    brand_id: 0,
                    lang
                  });
                }
              }
            });
          });
        }
      });
      if (isSubCat === 0 || isCat === 0){
        history.push(`/not-found`);
      }
    }

    else{
      return;
    }
    if(localStorage.getItem("user")){
      fetchOrderItems();
      fetchFavorites({ type: 0 });
    }
  }, [props.category, catrefid, subcatrefid, text, brandName]);

  //for waiting screen
  useEffect(() => {
    if(props.loading){
      setIsLoading(true);
      return;
    }
    if(isLoading && !props.loading || props.products.length > 0){
      setIsSpinning(false);
    }
    if(props.category.length > 0 && props.products.length === 0 && window.location.pathname.split("/").indexOf("search") >= 0 && props.loading === false) {
      setIsSpinning(false);
    }
  },[props.loading, props.products, catrefid])
  const location = useLocation();
  const Params = new URLSearchParams(location.search);

  useEffect(() => {
    const subCatId = localStorage.getItem('sug_sub_cat_id');
    const searchQuery = localStorage.getItem('search_query');
    if (subCatId < 0 || !subCatId) return;
    if(localStorage.getItem("mode") !== "search"){
      setTimeout(() => {
        localStorage.removeItem("search_query");
      }, 350);
    }
    if(Params) return;
    props.searchStoreProduct({
      sub_cat_id: subCatId,
      search_query: searchQuery?.replace(/[!@#$%^&*/']/g, " "),
      store_id: 1,
      page: 1
    });

    let timeout = setTimeout(() => {
      localStorage.removeItem("sug_sub_cat_id");
      localStorage.removeItem("search_query");
    }, 350);

    return () => clearTimeout(timeout);
  }, []);

  const [seenProductIds, setSeenProductIds] = useState([]);
  let url = window.location.pathname;
  let newUrl = url.split("/").filter(Boolean);
  const queryParams = window.location.search;

  const handleSeenProduct = (id) => {
    setSeenProductIds(prev => {
      if (prev.includes(id)) return prev;
      return [...prev, id];
    });
  };

  useEffect(() => {
    if (deviceType && deviceType.mobile && (seenProductIds.length % 4 == 0)) {
      logEventView(newUrl[0], queryParams[1], seenProductIds.length, JSON.stringify(seenProductIds));
    } else if (deviceType && deviceType.tablet && (seenProductIds.length % 8 == 0)) {
      logEventView(newUrl[0], queryParams[1], seenProductIds.length, JSON.stringify(seenProductIds));
    } else if (deviceType && deviceType.desktop && (seenProductIds.length % 16 == 0)) {
      logEventView(newUrl[0], queryParams[1], seenProductIds.length, JSON.stringify(seenProductIds));
    } 
  }, [seenProductIds])

  return (
    <>
  
      <div>
        {deviceType.desktop ? (
          <>
            <MainContentArea
              style={{ paddingTop: mql.matches ? "100px" : "0px" }}
            >
              {/* <div></div>  */}
              <ContentSection className='contentSection' id="productBlock" style={{width: "100%"}}>
                <div ref={targetRef}>
                  <Suspense fallback={<LazyLoader/>}>
                    {props.category.length > 0 &&
                    <>
                      <div className="d-flex" style={{width:"100%"}}>
                          {/* <svg xmlns="http://www.w3.org/2000/svg" onClick={openFilterModal} height="48" viewBox="0 -960 960 960" width="48"><path d="M427-120v-225h60v83h353v60H487v82h-60Zm-307-82v-60h247v60H120Zm187-166v-82H120v-60h187v-84h60v226h-60Zm120-82v-60h413v60H427Zm166-165v-225h60v82h187v60H653v83h-60Zm-473-83v-60h413v60H120Z" /></svg> */}
                          <Breadcrumb style={{width:"100%"}}>
                            {/* <svg xmlns="http://www.w3.org/2000/svg" onClick={openFilterModal} style={{ marginRight: "5px", cursor: "pointer" }} height="40" viewBox="0 -960 960 960" width="40"><path d="M120-240v-60h240v60H120Zm0-210v-60h480v60H120Zm0-210v-60h720v60H120Z" /></svg> */}
                            <MButton
                              variant="contained"
                              style={{
                                minWidth: 54,
                                marginInlineEnd: 10,
                                padding: 6,
                                backgroundColor: "#e9ecef",
                              }}
                              onClick={openFilterModal}
                            >
                              <Tune style={{ fontSize: 26 }} />
                            </MButton>
                            {/* <svg xmlns="http://www.w3.org/2000/svg" fill="gray" style={{ cursor: "pointer", marginRight: "5px", marginRight: "5px"}} onClick={openFilterModal} height="30" viewBox="0 -960 960 960" width="30"><path d="M440-160q-17 0-28.5-11.5T400-200v-240L161-745q-14-17-4-36t31-19h584q21 0 31 19t-4 36L560-440v240q0 17-11.5 28.5T520-160h-80Zm40-276 240-304H240l240 304Zm0 0Z" /></svg> */}
                            {/* <span style={{borderRight:"1px solid gray",margin:"0 5px",marginRight:"10px"}}></span> */}
                            <BreadcrumbItem href={"/"} className="home_breadCrumb_style" style={{ display: "flex", alignItems: "center" }}>{ t('shop_address_home_label') }</BreadcrumbItem>
                            {breadCrumbmatch()}
                          </Breadcrumb>
                        </div>
                      {brandFetching ? null : brandLogo()}
                      </>
                    }
                    {
                      isSpinning ? (
                        null
                      ):(
                        <Products
                          type={PAGE_TYPE}
                          deviceType={deviceType}
                          fetchLimit={16}
                          props={props}
                          brandName={brandName}
                          isFilterModal={showFilter}
                          toggleFilter={openFilterModal}
                          onSeenProduct={handleSeenProduct}
                        />                        
                      )
                    }
                  </Suspense>
                </div>
              </ContentSection>
            </MainContentArea>
          </>
        ) : (
          <MainContentArea style={{ paddingTop: mqs.matches ? "9vh" : "0px" }}>
            {/* <StoreNav items={storeType} /> */}
            {/* {props.sliders.length > 0 ? (
              <OfferSection>
                <div className="offer-mobile">
                  <Carousel deviceType={deviceType} data={props.sliders} />
                </div>
              </OfferSection>
            ) : null} */}
            <ContentSection style={{ width: "100%" }}>
            <Suspense fallback={<LazyLoader/>}>
              {props.category.length > 0 && window.location.pathname.split("/").indexOf("search") < 0 &&
                <div className="d-flex" style={{width: "100%" }}>
                {/* <svg xmlns="http://www.w3.org/2000/svg" onClick={openFilterModal} height="48" viewBox="0 -960 960 960" width="48"><path d="M427-120v-225h60v83h353v60H487v82h-60Zm-307-82v-60h247v60H120Zm187-166v-82H120v-60h187v-84h60v226h-60Zm120-82v-60h413v60H427Zm166-165v-225h60v82h187v60H653v83h-60Zm-473-83v-60h413v60H120Z" /></svg> */}
                 <Breadcrumb style={{ width: "100%" }}>
                        {/* <svg xmlns="http://www.w3.org/2000/svg" onClick={openFilterModal} style={{ marginRight: "5px",cursor:"pointer" }} height="40" viewBox="0 -960 960 960" width="40"><path d="M120-240v-60h240v60H120Zm0-210v-60h480v60H120Zm0-210v-60h720v60H120Z" /></svg> */}
                        <MButton
                            variant="contained"
                            style={{
                              minWidth: 54,
                              marginInlineEnd: 10,
                              padding: 6,
                              backgroundColor: "#e9ecef",
                            }}
                            onClick={openFilterModal}
                          >
                            <Tune style={{ fontSize: 26 }} />
                          </MButton>
                        {/* <svg xmlns="http://www.w3.org/2000/svg" fill="gray" style={{ cursor: "pointer", marginRight: "5px", marginRight: "5px", borderRight: "1px solid gray" }} onClick={openFilterModal} height="30" viewBox="0 -960 960 960" width="30"><path d="M440-160q-17 0-28.5-11.5T400-200v-240L161-745q-14-17-4-36t31-19h584q21 0 31 19t-4 36L560-440v240q0 17-11.5 28.5T520-160h-80Zm40-276 240-304H240l240 304Zm0 0Z" /></svg> */}
                        <BreadcrumbItem href={"/"} className="home_breadCrumb_style" style={{ display: "flex", alignItems: "center" }}>{ t('shop_address_home_label') }</BreadcrumbItem>
                    {breadCrumbmatch()}
                  </Breadcrumb>
                </div>
              }
              {
                isSpinning ? (
                  null
                ):(
                  <Products
                    type={PAGE_TYPE}
                    deviceType={deviceType}
                    fetchLimit={16}
                    props={props}
                    brandName={brandName}
                    isFilterModal={showFilter}
                    toggleFilter={openFilterModal}
                    onSeenProduct={handleSeenProduct}
                  />                  
                )
              }

              </Suspense>
            </ContentSection>
          </MainContentArea>
        )}
        {/* {isSpinning ?
        <div className="spinner text-center mt-5">
          <Spinner className='mr-1' as="span" animation="border" role="status" aria-hidden="true"/>
        </div>
        : null } */}
        <CartPopUp deviceType={deviceType} />
        {isSpinning ?
              <WaitingScreen>
                <Spinner className='mr-1' as="span" animation="border" role="status" aria-hidden="true"/>
              </WaitingScreen>
              : null }
        {/* <Modal
          show={showBN && getCookie('furthernotice') !== "seen" &&  (window.location.pathname.indexOf("la-ferme-de-bassac") !== -1  || window.location.pathname.indexOf("bassac-caterer") !== -1 || window.location.pathname.indexOf("butcher-corner") !== -1)}
          onHide={() => {
            setShowBN(false);
            setCookie('furthernotice','seen', 30);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>An Important Notice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <p>Dear customer,</p>
              <p>We just want to inform you that Bassac Farm and Bassac Caterer (Le Votre) are closed until further notice and their products are not available.</p>
              <p>Sorry for the inconvenience and have a great day.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              title="I understand"
              variant="primary"
              onClick={() => {setShowBN(false);setCookie('furthernotice','seen', 30);}}
            >
              I understand
            </Button>
          </Modal.Footer>
        </Modal> */}
      </div>
    </>
  );
};
SearchedResults.getInitialProps = async (appContext) => {
  const { req } = appContext.ctx;
  const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
  return { userAgent };
};
const mapStateToProps = (state) => {
  return {
    success: state.authReducer.success,
    modalData: state.productReducer.modalData,
    products: state.productReducer.products,
    allproducts: state.productReducer.allproducts,
    isHasMore: state.productReducer.isHasMore,
    category: state.productReducer.category,
    sliders: state.globalReducer.sliders,
    loading: state.globalReducer.loading,
    brands: state.productReducer.brands,
    brandDetail: state.productReducer.brandDetail,
    filterBrands: state.productReducer.filterBrands,
    FilteredNameProducts: state.productReducer.FilteredNameProducts,
    filteredProducts: state.productReducer.filteredProducts,
    suggested_subcats: state.productReducer.suggested_subcats,
    all_suggested_subcats: state.productReducer.all_suggested_subcats,
    oos: state.globalReducer.oos,
    page: state.productReducer.page,
    cat_refs: state.productReducer.cat_refs
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    productCategory: (data) => productCategory(data, dispatch),
    ProductModalData: (data) => ProductModalData(data, dispatch),
    searchSuggestions: (data) => searchSuggestions(data, dispatch),
    searchStoreProduct: (data) => searchStoreProduct(data, dispatch),
    getProductsMappedwithSubCat: (data) => getProductsMappedwithSubCat(data, dispatch),
    getProductsMappedwithCat: (data) => getProductsMappedwithCat(data, dispatch),
    offerSlider: (data) => offerSlider(data, dispatch),
    getProductOutOfStock: (body) => getProductOutOfStock(body, dispatch),
    getProductOutOfStockCat: (body) => getProductOutOfStockCat(body, dispatch),
    getProductBrands: () => getProductBrands(dispatch),
    getBrandByName: (data) => getBrandByName(data ,dispatch),
    getBrandBySlug: (slug) => getBrandBySlug(slug ,dispatch),
    getSortProductsName: (type, products) =>
      getSortProductsName(type, products, dispatch),
    getSortProductsPrice: (type, products) =>
      getSortProductsPrice(type, products, dispatch),
    getProductFilterBrands: (body, products, allproducts, sub_cat_id, cat_id, brandName, oos, text) =>
      getProductFilterBrands(body, products, allproducts, sub_cat_id, cat_id, brandName, oos, text, dispatch),
    sortByNameProduct: (type, products) =>
      sortByNameProduct(type, products, dispatch),
    SearchStoreProductByBrandRef: (body) => SearchStoreProductByBrandRef(body, dispatch),
    oosModified: (data) => oosModified(data, dispatch),
    Toggle_Suggestions: (data) => Toggle_Suggestions(data, dispatch),
    changePage: (data) => changePage(data, dispatch),
    resetPage: () => resetPage(dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SearchedResults);


const QuickViewWrapper = styled.div`
a {
  color: #4b4a49;
}
@media (max-width: 425px) {
  .breadcrumb{
    padding: 0.5rem 0.75rem;
    font-size: 14px;    
  }
}
`;